import type { ComponentType } from 'react'
import type { UserRole } from '@/entities/session/types'
import {
  FileTextIcon,
  HomeIcon,
  MenuIcon,
  UsersIcon,
  CalendarClockIcon,
} from '@/shared/ui/icons'

export const plantoesNavigationItem: NavigationItem = {
  to: '/plantoes',
  label: 'Plantões',
  icon: CalendarClockIcon,
}

export interface NavigationItem {
  to: string
  label: string
  /** Rótulo alternativo só na barra inferior (mobile). Cai para `label` quando ausente. */
  mobileLabel?: string
  icon: ComponentType<{ className?: string; size?: number }>
  /** 'menu' abre o bottom sheet em vez de navegar. */
  kind?: 'link' | 'menu'
}

const prescriptionNavByRole: Record<UserRole, NavigationItem> = {
  doctor: {
    to: '/documentos',
    label: 'Documentos',
    icon: FileTextIcon,
  },
  patient: {
    to: '/documentos',
    label: 'Documentos',
    icon: FileTextIcon,
  },
  admin: {
    to: '/documentos',
    label: 'Documentos',
    icon: FileTextIcon,
  },
}

const homeItem: NavigationItem = { to: '/dashboard', label: 'Hoje', icon: HomeIcon }
const patientsItem: NavigationItem = { to: '/patients', label: 'Pacientes', icon: UsersIcon }

const settingsItem: NavigationItem = {
  to: '/settings',
  label: 'Configurações',
  // Na barra inferior (mobile) este item abre a folha Mais — o rótulo reflete a ação, não o destino.
  mobileLabel: 'Mais',
  icon: MenuIcon,
  kind: 'menu',
}

/** SHELL-01: Hoje · Documentos · Pacientes · Mais. */
export const getNavigationItems = (role: UserRole): NavigationItem[] => [
  homeItem,
  prescriptionNavByRole[role],
  patientsItem,
  settingsItem,
]

export const primaryNavigationItems: NavigationItem[] = getNavigationItems('doctor')
